import { defineMessages } from "react-intl";

import TargetType from "@app/enum/dashboard/TargetType";

export const targetTypeDisplayName = defineMessages<TargetType>({
  [TargetType.INDIVIDUAL]: {
    id: "dashboard.editModal.configuration.goal.targetType.individual",
    defaultMessage: "Set goals specific to each user",
    description: "Individual goal target Create/Edit Card modal on the Dashboard page",
  },
  [TargetType.MEMBERS]: {
    id: "dashboard.editModal.configuration.goal.targetType.members",
    defaultMessage: "Each member has an equal goal, excluding managers",
    description: "Members-only goal target Create/Edit Card modal on the Dashboard page",
  },
  [TargetType.TEAM]: {
    id: "dashboard.editModal.configuration.goal.targetType.team",
    defaultMessage: "Each member has an equal goal, including managers",
    description: "Team goal target Create/Edit Card modal on the Dashboard page",
  },
});

export const targetTypeDescription = defineMessages<TargetType>({
  [TargetType.INDIVIDUAL]: {
    id: "dashboard.editModal.configuration.goal.targetType.individual.description",
    defaultMessage:
      "Based on your selection, each member or manager in {team} can have a <b>unique goal</b>. You can set a default goal below. Individual member goals can be set on this chart’s settings from their dashboard.",
    description:
      "Description for Individual goal target Create/Edit Card modal on the Dashboard page",
  },
  [TargetType.MEMBERS]: {
    id: "dashboard.editModal.configuration.goal.targetType.members.description",
    defaultMessage:
      "Based on your selection, each <b>member</b> in {team} is expected to contribute equally in order to reach the team goal. Managers will not have an individual goal.",
    description:
      "Description for Members-only goal target Create/Edit Card modal on the Dashboard page",
  },
  [TargetType.TEAM]: {
    id: "dashboard.editModal.configuration.goal.targetType.team.description",
    defaultMessage:
      "Based on your selection, each <b>member and manager</b> in {team} is expected to contribute equally in order to reach the team goal.",
    description: "Description for Team goal target Create/Edit Card modal on the Dashboard page",
  },
});

export const messages = defineMessages({
  defaultTargetLabel: {
    id: "dashboard.editModal.configuration.goal.defaultTarget",
    defaultMessage: "Default Individual Goal",
    description: "Default Goal label in Create/Edit Card modal on the Dashboard page",
  },
  individualGoal: {
    id: "dashboard.editModal.configuration.goal.individualGoal",
    defaultMessage: "Individual Goal",
    description: "Individual Goal label in Create/Edit Card modal on the Dashboard page",
  },
});
